// extracted by mini-css-extract-plugin
export var active = "_lh-2";
export var recordingDot = "_lh-1";
export var recordingIndicator = "_lh-0";